import React from "react";
import { Helmet } from "react-helmet";
import Header from "../../../../../components/default/header";
import StoreSidebarMenu from "../../../menu/storeSidebarMenu";
import Breadcrumb from "../../../../default/breadcrumb/breadcrumb";
import ServiceData from "./serviceData";

const UserStore = () => {
    return (
        <div className="menu-with-settings sidebar-menu-enable">
            <Helmet><title>User Store</title></Helmet>
            <Header />
            <div className="sidebar-with-content ds-flex">
                <StoreSidebarMenu />
                <div className="content-right">
                    <Breadcrumb />
                    <div class="connection-header common-header">
                        <h3>Services</h3>
                    </div>
                    <ServiceData />
                </div>
            </div>
        </div>

    );
}

export default UserStore;